import './header.css'
import { Link } from "react-router-dom";
import Sidebar from '../sidebar/sidebar';
import { useState } from 'react';
import menuIcon from '../../assets/images/menu.png'
import topbarShape1 from '../../assets/images/topbar-shape-1.png'
import topbarShape2 from '../../assets/images/topbar-shape-1.png'
import logoOne from '../../assets/images/logo-one.png'
import UserDropDown from './components/user_drop_down';

const Header = () => {
    const [toggle, setToggle] = useState(false)
    const activeLinkHandler = (path) => {
        if (window.location.pathname === path) {
            return 'active'
        }
    }

    return (
        <>
            <Sidebar
                toggle={toggle}
                setToggle={setToggle}
            />
            <div className="header-area">
                <div className="container-fluid">
                    <div className="row align-items-center">
                        <div className="col-lg-8">
                            <div className="single-header-left-content">
                                <ul>
                                    <li>
                                        <i className="flaticon-phone-call"></i>
                                        <a href="tel:+923061922327">+923061922327</a>
                                    </li>
                                    <li>
                                        <i className="flaticon-email"></i>
                                        <a href="mailto:usama@thejunestore.com"><span className="__cf_email__">usama@thejunestore.com</span></a>
                                    </li>
                                    <li>
                                        <i className="flaticon-pin"></i>Lahore, Pakistan
                                    </li>
                                </ul>
                            </div>
                        </div>
                        <div className="col-lg-4">
                            <div className="single-header-right-list">
                                <ul>
                                    <li>
                                        <a href="https://www.facebook.com/" target="_blank">
                                            <i className="flaticon-facebook"></i>
                                        </a>
                                    </li>
                                    <li>
                                        <a href="https://twitter.com/" target="_blank" className="border-twitter">
                                            <i className="flaticon-twitter"></i>
                                        </a>
                                    </li>
                                    <li>
                                        <a href="https://www.youtube.com/" target="_blank">
                                            <i className="flaticon-youtube"></i>
                                        </a>
                                    </li>
                                    <li>
                                        <a href="https://www.instagram.com/" target="_blank" className="border-twitter">
                                            <i className="flaticon-instagram"></i>
                                        </a>
                                    </li>
                                </ul>
                            </div>
                        </div>
                    </div>
                </div>
                <div className="header-shape-1">
                    <img src={topbarShape1} alt="images" />
                </div>
                <div className="header-shape-2">
                    <img src={topbarShape2} alt="images" />
                </div>
            </div>

            <div className="navbar-area">
                <div className="main-nav">
                    <div className="container-fluid">
                        <nav className="navbar navbar-expand-md navbar-light">
                            <Link to="/" >
                                <img src={logoOne} className="logo-light" alt="images" />
                            </Link>
                            <div className="d-flex">
                                <div className="cart-nav">
                                    <Link to={'/cart'}><i className="fa-solid fa-cart-shopping"></i><sup>5</sup></Link>
                                </div>
                                <div className="hamburger">
                                    <img src={menuIcon} alt="" onClick={() => setToggle(true)} />
                                </div>
                            </div>
                            <div className="collapse navbar-collapse mean-menu" id="navbarSupportedContent">
                                <ul className="navbar-nav ms-auto">
                                    <li className="nav-item">
                                        <Link to="/" className={`nav-link ${activeLinkHandler('/')}`}>
                                            Home
                                        </Link>
                                    </li>
                                    <li className="nav-item">
                                        <Link to={'/services'} className={`nav-link ${activeLinkHandler('/services')}`}>
                                            Services
                                        </Link>
                                    </li>
                                    <li className="nav-item">
                                        <Link to={'/blogs'} className={`nav-link ${activeLinkHandler('/blogs')}`}>Blogs</Link>
                                    </li>
                                    <li className="nav-item">
                                        <Link to={'/about'} className={`nav-link ${activeLinkHandler('/about')}`}>About</Link>
                                    </li>
                                    <li className="nav-item">
                                        <Link to={'/contact'} className={`nav-link ${activeLinkHandler('/contact')}`}>Contact Us</Link>
                                    </li>
                                </ul>

                                <div className="others-option-vg d-flex align-items-center">
                                    <div className="option-item">
                                        <button type="button" className="search-btn" data-bs-toggle="modal" data-bs-target="#exampleModal" data-bs-whatever="@mdo">
                                            <i className="flaticon-search"></i>
                                        </button>
                                        <button type="button" className="search-btn" >
                                            <Link style={{ color: '#002434' }} to={'/cart'}><i className="fa-solid fa-cart-shopping"></i><sup>5</sup></Link>
                                        </button>
                                    </div>
                                    <div className="option-item">
                                        <UserDropDown />
                                    </div>
                                    <div className="option-item">
                                        {
                                            window.location.pathname === "/login" ?
                                                <Link to={'/register'} className="default-btn">Register</Link> :
                                                <Link to={'/login'} className="default-btn">Login</Link>
                                        }
                                        <Link to={'/provider-login'} className="default-btn">Service Provider</Link>
                                    </div>
                                </div>
                            </div>
                        </nav>
                    </div>
                </div>
            </div >
        </>
    )
}

export default Header